import { h, render } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { fetchList } from '../../wishlist/index';
import { ShowWishlist } from './ShowWishlist';
import { t } from '../../theme/locales';
const SharedWishlistPage = ({ bannerImage  })=>{
    const [wishlist, setWishlist] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(()=>{
        const fetchWishlist = async ()=>{
            try {
                if (!window._swat) {
                    console.error('Swym API not initialized');
                    return;
                }
                const swat = window._swat;
                const urlParams = new URLSearchParams(window.location.search);
                const lid = urlParams.get('lid');
                if (!lid) {
                    console.error('No wishlist ID (lid) found in URL');
                    return;
                }
                const list = await fetchList(lid, swat);
                if (list) {
                    setWishlist(list);
                } else {
                    console.error('Wishlist not found for lid:', lid);
                }
            } catch (error) {
                console.error('Error fetching shared wishlist:', error);
            } finally{
                setLoading(false);
            }
        };
        window.addEventListener('swym:ready', fetchWishlist);
        return ()=>{
            window.removeEventListener('swym:ready', fetchWishlist);
        };
    }, []);
    if (loading) {
        return h('div', {
            className: 'wishlist-page'
        }, [
            h('div', {
                role: 'status',
                'aria-live': 'polite'
            }, t('wishlist.loading_shared'))
        ]);
    }
    if (!wishlist) {
        return h('div', {
            className: 'wishlist-page'
        }, [
            h('p', null, t('wishlist.shared_not_found'))
        ]);
    }
    return h('div', {}, [
        h('div', {
            className: 'wishlist-banner'
        }, [
            h('div', {
                className: 'wishlist-banner__content'
            }, [
                h('div', {
                    className: 'wishlist-banner__layer'
                }, []),
                h('div', {
                    className: 'wishlist-banner__image'
                }, [
                    h('img', {
                        src: bannerImage || 'https://cdn.swymrelay.com/swym/wishlist-banner.png',
                        alt: t('wishlist.banner_alt')
                    })
                ]),
                h('h1', {
                    className: 'wishlist-banner__title'
                }, wishlist.lname)
            ])
        ]),
        h('div', {
            className: 'wishlist-page'
        }, [
            h(ShowWishlist, {
                wishlist,
                showHeartIcon: false
            })
        ])
    ]);
};
export const init = async function() {
    const container = document.getElementById('js-shared-wishlist-page');
    if (!container) {
        return;
    }
    render(h(SharedWishlistPage, {
        bannerImage: container.getAttribute('data-image-banner')
    }), container);
};
